import React from 'react'
import BuildItems from './BuildItems'
import './style.css'

const LeftPane = ({ onBuildItemSelected, selectedBuildItemType }) => (
  <div className="home-body-left-pane">
    <span className="home-body-left-pane-title">
      You can build it with Drift
    </span>
    <BuildItems
      onBuildItemSelected={onBuildItemSelected}
      selectedBuildItemType={selectedBuildItemType}
    />
  </div>
)

export default LeftPane
